import styled, { keyframes } from 'styled-components';

import { CircularProgress, TextField } from '@material-ui/core';

import ICoresData from '../../context/ICoresData';

interface CoresProps {
  cores: ICoresData;
}

interface ObjetosProps {
  percentual_tela?: number;
  ehCartao?: boolean;
}

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeIn = keyframes`
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
`;

export const Container = styled.div`
  animation: ${appearFromLeft} 1s;

  /* 100% da parte visível da tela - total da altura */
  /* height: 100vh; */

  display: flex;
  flex-direction: column;
  align-items: center;

  z-index: 1;

  min-height: 90vh;
  position: relative;

  padding: 20px 50px 30px 50px;
`;

export const LoadingContainer = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const Loading = styled(CircularProgress)`
  &.MuiCircularProgress-colorPrimary {
    color: var(--cor-login-contorno-input);
  }
`;

export const LinhaBuscar = styled.div`
  display: flex;
  margin-top: 8px !important;
  animation: ${fadeIn} 1s;
`;

export const InputData = styled(TextField)`
  width: 150px;
  @media (max-width: 610px) {
    width: 142px;
  }
  margin-right: 8px !important;
`;

export const InputMes = styled(TextField)`
  width: 210px;
  margin-right: 8px !important;
`;

export const InputAno = styled(TextField)`
  width: 75px;
  margin-right: 8px !important;
`;

export const BotaoPesquisar = styled.div<CoresProps>`
  width: 80px; //tava 100%
  display: flex;
  margin-bottom: 0px;
  margin-top: 18px;
  padding: 0 8px;

  button {
    background: ${props => props.theme.fundoMenu};
    border-radius: 8px 8px 8px 8px;
    border: none;
    flex: 1;
    /* width: 100%; */

    height: 50px;
    color: #fff;

    transition: color 0.3s;
    transition: background-color 0.1s;

    &:hover {
      /* background-color: ${props => props.cores.secundariaShade}; */
      background-color: var(--cor-fonte-hover);
    }

    &:active {
      /* background-color: ${props => props.cores.primaria}; */
      background-color: var(--cor-fonte-hover);
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        height: 32px;
        width: 32px;
        margin-right: 4px;
      }

      span {
        font-size: 18px;
      }
    }
  }
`;

export const TooltipContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
`;

export const TooltipText = styled.p`
  margin: 0; /* Opcional: Remove margens padrão */
`;

export const TooltipStrong = styled.strong`
  font-weight: bold;
`;

export const SecaoContainer = styled.div`
  display: flex;
  flex-wrap: wrap; // Permite quebrar para nova linha
  gap: 10px; // Espaçamento entre gráficos
  width: 100%;
  justify-content: center; // Centraliza os gráficos quando quebra para nova linha
`;

export const ObjetoContainer = styled.div<ObjetosProps>`
  flex: 1 1 calc(${props => props.percentual_tela}% - 10px); // Ajusta largura considerando o gap
  min-width: 340px; // Largura mínima para gráficos
  max-width: calc(
    ${props => `${props.percentual_tela}% - 10px`}
  ); // Limita largura máxima
  height: 400px;
  background-color: ${props => props.theme.fundoObjeto};
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  margin-top: 16px;
`;

export const ObjetoTitulo = styled.h2<ObjetosProps>`
  text-align: center;
  font-family: Arial, sans-serif;
  color: ${props => props.theme.textoObjeto};
  // marginBottom: 10px;
  margin-bottom: 2px;
  margin-top: ${props => (props.ehCartao ? '52px' : '8px')};
  font-weight: 600;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
  /* letter-spacing: 0.3px; */
  /* font-size: clamp(24px, 1.8vw, 28px);  */
`;

export const AnimatedCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%; /* Ocupar todo o espaço disponível */
  animation: ${appearFromLeft} 1s; /* Aplica a animação */
`;

export const CartaoValor = styled.p<{
  temDescricao: boolean;
  temPercentual: boolean;
}>`
  font-size: clamp(20px, 8vw, 52px);
  color: ${props => props.theme.textoObjeto};
  margin: 0;
  font-weight: bold;
  margin-top: ${props =>
    !props.temDescricao && !props.temPercentual
      ? '86px'
      : !props.temDescricao || !props.temPercentual
      ? '76px'
      : '72px'};
  margin-bottom: 36px;
`;

export const CartaoPercentual = styled.p<{ temPercentual: boolean }>`
  font-size: clamp(12px, 6vw, 28px);
  color: ${props => (props.temPercentual ? '#4CAF50' : '#FF5252')};
  margin: 5px 0;
  font-family: Arial, sans-serif;
  margin-bottom: 8px;
`;

export const CartaoDescricao = styled.p`
  font-size: clamp(10px, 6vw, 20px);
  color: ${props => props.theme.textoObjeto};
  margin: 0 0 10px 0;
  font-family: Arial, sans-serif;
`;
